import { render, staticRenderFns } from "./DefectChecker.vue?vue&type=template&id=314d4863"
import script from "./DefectChecker.vue?vue&type=script&lang=js"
export * from "./DefectChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports